import { faCopy, faExternalLink } from "@fortawesome/pro-solid-svg-icons";
import { MultiButton, SlimButton } from "components/Button";
import { openCreateExAgentSaleModal } from "lib/navigation";
import React from "react";
import { useSelector } from "react-redux";
import {
  getIsOnline,
  selectCanCreateExternalAgentSaleFromSale,
} from "selectors";
import { LivestockSaleAgGridRowType } from "selectors/aggrid/sales";

interface LivestockSaleActionsColumnRendererProps {
  data: LivestockSaleAgGridRowType;
  context: {
    handleOpenSale: (livestockSaleId: number) => void;
  };
}

export function LivestockSaleActionsColumnRenderer(
  props: LivestockSaleActionsColumnRendererProps,
): React.JSX.Element {
  const { data, context } = props;

  const { handleOpenSale } = context;

  const isOnline = useSelector(getIsOnline);

  const canCreateExternalAgentSaleFromSale = useSelector(
    selectCanCreateExternalAgentSaleFromSale,
  );

  if (!data) {
    return null;
  }

  const onOpenSaleClick = () => {
    handleOpenSale(data.livestockSale.id);
  };

  const onCreateExternalAgentSaleFromSale = () => {
    openCreateExAgentSaleModal(data.livestockSale.id);
  };

  const buttons = [
    {
      onClick: onOpenSaleClick,
      dataTour: `action-open-sale:${data.livestockSale.id}`,
      icon: faExternalLink,
      title: " Open",
    },
    canCreateExternalAgentSaleFromSale && {
      onClick: onCreateExternalAgentSaleFromSale,
      dataTour: `action-create-ex-agent-sale:${data.livestockSale.id}`,
      icon: faCopy,
      title: " Create Ex Agent Sale",
      isDisabled: !isOnline,
    },
  ].filter(Boolean);

  return <MultiButton buttons={buttons} ButtonComponent={SlimButton} />;
}
